(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/shared-components/header-text.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/shared-components/header-text.js');

'use strict';

const {
  bankidProgressStatus,
  frejaeIdProgressStatus,
  appWaitStatus
} = svs.playerLogin.constants;

const HeaderText = _ref => {
  let {
    isLogin = true,
    isBankId,
    pollWait = appWaitStatus.WAITING_QRCODE
  } = _ref;
  const frejaeIdBackendStatus = ReactRedux.useSelector(state => state.playerloginreact.frejaeIdBackendStatus);
  const bankIdBackendStatus = ReactRedux.useSelector(state => state.playerloginreact.bankIdBackendStatus);
  const waitStatus = isBankId ? bankIdBackendStatus : frejaeIdBackendStatus;
  const progressStatus = isBankId ? bankidProgressStatus : frejaeIdProgressStatus;
  const [showTitle, setShowTitle] = React.useState(true);
  const waitingApp = waitStatus === progressStatus.WAITING_APP && pollWait === appWaitStatus.WAITING_SSNAPP;
  const waitingVerifyQrCode = waitStatus === progressStatus.SHOWING_SPINNER || waitStatus === progressStatus.NEW_CUSTOMER || waitStatus === progressStatus.RETAIL_CUSTOMER || waitStatus === progressStatus.ONLINE_CUSTOMER;
  React.useEffect(() => {
    if (waitingApp || waitingVerifyQrCode) {
      setShowTitle(false);
    }
  }, [waitingApp, waitingVerifyQrCode]);
  return React.createElement(React.Fragment, null, isLogin && showTitle && React.createElement("div", {
    className: "margin-top-1 align-center"
  }, React.createElement("h1", {
    className: "padding-top-2 login-react-header-text f-bold"
  }, "Hej och v\xE4lkommen!")), !isLogin && showTitle && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "margin-xs-top-3 align-center"
  }, React.createElement("h1", {
    className: "login-react-header-text f-bold margin-bottom-1"
  }, "Kom ig\xE5ng som kund!")), React.createElement("h2", {
    className: "align-center login-react-header2-text f-bold"
  }, "N\xE5gra f\xE5 enkla steg - sen kan du b\xF6rja spela.")));
};
svs.playerLogin.sharedComponents.HeaderText = HeaderText;

 })(window);